// extracted by mini-css-extract-plugin
export default {"card":"contentCard_card__FuWHB","transparent":"contentCard_transparent__1uWLg"};